import * as React from 'react';
import { GlobalSearchResultType, GlobalSearchResultTypeUnionType } from '@api';
import { Spotlight, SpotlightActionProps } from '@mantine/spotlight';
import { createLink } from '@tanstack/react-router';
import { getNavigationPath } from './helpers';

type ActionPropsType = {
  action: GlobalSearchResultType;
  type: GlobalSearchResultTypeUnionType;
};

const MantineActionLink = React.forwardRef<
  HTMLButtonElement,
  SpotlightActionProps
>((props, ref) => {
  return <Spotlight.Action component="a" ref={ref} {...props} />;
});

MantineActionLink.displayName = 'MantineActionLink';

const CreatedActionLink = createLink(MantineActionLink);

export const Action: React.FC<ActionPropsType> = ({ action, type }) => {
  const navigationPath = getNavigationPath(type, action.id);

  return (
    <CreatedActionLink
      key={action.id}
      {...navigationPath}
      label={action.label}
      highlightQuery
    />
  );
};
